module.exports = __webpack_public_path__ + "static/bike3.8ed83a68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bike3.jpg
// module id = 132
// module chunks = 37880801899593 263791100135453